import React from 'react';
import Modal from '../../../@lib/components/Modal/Modal';
import { Button, Typography } from '../../../@lib/core';
import { useUIStore } from '../../../store/ui';
import * as styles from './ErrorModal.module.css';

function ErrorModal() {
  const { errorModal, hideError } = useUIStore();

  return (
    <Modal open={errorModal.open} onClose={hideError}>
      <div className={styles.content}>
        <Typography variant="h5" fontWeight="bold" color="black">
          {errorModal.title}
        </Typography>
        <p className={styles.message}>{errorModal.message}</p>
        <div className={styles.actions}>
          <Button color="primary" size="large" fullWidth onClick={hideError}>
            Fechar
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ErrorModal;
